import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoginPage } from '@/features/auth/login-page';
import { supabase } from '@/lib/supabase';

export const Route = createFileRoute('/login')({
  component: LoginPage,
  beforeLoad: async () => {
    // Si ya hay sesión, no tiene sentido mostrar /login.
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      throw redirect({ to: '/' });
    }
  },
});
